import { SxProps, Theme } from '@mui/material'

/**
 * Shared DataGrid styling for the admin tables. Vertically centers the footer
 * pagination controls (the "Rows per page" select otherwise sits too high
 * because of the global font/line-height).
 */
export const adminDataGridSx: SxProps<Theme> = {
  '& .MuiTablePagination-toolbar': {
    alignItems: 'center',
  },
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    marginTop: 0,
    marginBottom: 0,
  },
  '& .MuiTablePagination-select': {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
  '& .MuiTablePagination-selectIcon': {
    top: 'auto',
  },
}
